import {
    AUTH_USER
} from "../constant";

const initialState = {
    isAuth: false,
    name: "",
    id: ""
};

const authReducer = (state = initialState, action) => {

    switch (action.type) {
        case AUTH_USER:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}

export default authReducer;